import React, { useEffect, useState } from 'react'
import './index.sass'
import moment from 'moment';
import { useSelector } from 'react-redux';
import { toggleNotification } from '../../api/chat';


function Usercard({ click, data }) {
    const loggedInUser = useSelector(state => state.userState.id);
    const [notification, setNotification] = useState(null);
    const [read, setRead] = useState(null)


    const getTimeAgo = (time) => {
        try {
            return moment(new Date((time.seconds + time.nanoseconds * 10 ** -9) * 1000)).fromNow()
        } catch (e) { }
    }

    useEffect(() => {
        setNotification(data.notification[`${loggedInUser}`])
        setRead(data.read[`${loggedInUser}`])
    }, [data.notification, data.read])

    const handleClick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        click(data)
    }

    
    if (data.msg == "")
        return null

    return (
        <div className="chat-user-card" onClick={handleClick} >
            <div className="user-content" >
                <img src={data.user.image} />
                <div>
                    <h3>{data.user.name}</h3>
                    <h5>{`${data.msg.text.slice(0, 20)}`}</h5>
                    <p>{getTimeAgo(data.msg.timestamp)}</p>
                </div>
            </div>
            {notification != null && notification == false && <img className="mute-notif" src={require('../../assets/icons/notification_mute.svg')} />}
        </div>
    )
}

export default (Usercard)